module.exports = __webpack_public_path__ + "img/logoFull.b9e4d9aa.svg";